import React from 'react';

export const PrivacyPolicy: React.FC = () => (
  <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
    <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-2">Privacy Policy</h1>
    <p className="text-gray-500 dark:text-gray-400 mb-8">Last updated: March 2026</p>

    <div className="prose dark:prose-invert max-w-none space-y-6 text-gray-700 dark:text-gray-300 text-sm leading-relaxed">
      <section>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">1. Information We Collect</h2>
        <p>We collect information you provide when creating an account, including your name, email address, phone number, and country. We also collect transaction data when you purchase tickets or request withdrawals.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">2. How We Use Your Information</h2>
        <p>Your information is used to operate the platform, process transactions, notify you of draw results, prevent fraud, and improve our services. We may also use your email to send important account-related communications.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">3. Payment Processing</h2>
        <p>Payments are processed by Paystack, a PCI-DSS compliant third-party provider. We do not store your credit card or bank account details on our servers.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">4. Data Sharing</h2>
        <p>We do not sell your personal information. We may share data with payment processors, cloud infrastructure providers, and law enforcement when required by law.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">5. Cookies and Analytics</h2>
        <p>We use essential cookies to maintain your session and preferences (such as theme selection). We may use analytics tools to understand how the platform is used and improve the experience.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">6. Data Security</h2>
        <p>We implement industry-standard security measures including encryption in transit (HTTPS), secure authentication tokens, and access controls to protect your data.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">7. Data Retention</h2>
        <p>We retain your account and transaction data for as long as your account is active and as required by applicable laws. You may request account deletion by contacting support.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">8. Your Rights</h2>
        <p>Depending on your jurisdiction, you may have the right to access, correct, or delete your personal data. Contact us through the Contact Us page to exercise these rights.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">9. Changes to This Policy</h2>
        <p>We may update this Privacy Policy from time to time. We will notify you of significant changes via email or an in-app notice.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">10. Contact</h2>
        <p>For privacy-related inquiries, please reach out through the Contact Us page.</p>
      </section>
    </div>
  </div>
);
